/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import Menu from './menu'
import WebMarket from './sub_components/webmarket'
import Fancybook from './fancybook'
import Toast from './sub_components/toast'
import * as orderService from '../services/orderService'
import * as eventService from '../services/eventService'
import ExpoPopup from './sub_components/expoPopup';
import BetSlipPopup from './sub_components/betSlipPopup';
import * as authUtil from "../util/auth.util";
let mBets = []
let umBets = []
class Event extends Component {
    constructor(props) {
        super(props);
        this.state = {
            game: {},
            event: {},
            gameCode: "",
            selected_market: null,
            selcted_bet_option: null,
            matched_bet: [],
            unmatched_bet: [],
            selected_list: "matched",
            frontData: {},
            runners: [],
            showToast: false,
            toastMsg: "",
            toastType: "",
            loading: false,
            fancyMarkets: [],
            lineMarkets: [],
            showExpo: false,
            lineExpo: {},
            tvUrl: "",
            tvShow: true,
            teamSequence: [],
            loadingBet: false,
            mktFeedBooks: {},
            pinnedEvents: [],
            betLimit: 20,
            betSlipOpen: false,
            deactivatMarkets: []
        };
    }
    detectMob() {
        const toMatch = [
            "/Android/i",
            "/webOS/i",
            "/iPhone/i",
            "/iPad/i",
            "/iPod/i",
            "/BlackBerry/i",
            "/Windows Phone/i"
        ];
        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    }
    updateBook(marketId, book) {
        let feedBooks = this.state.mktFeedBooks
        feedBooks[marketId] = book
        this.state.mktFeedBooks = feedBooks
    }
    addBet(bet) {
        this.setState({ loadingBet: true })
        bet.event_name = this.state.game.event.name
        bet.competition_Name = this.state.game.competition.name
        let betData = JSON.parse(localStorage.getItem("betForm"))
        let body = {
            marketId: bet.marketId,
            placeInstruction: {
                orderType: "LIMIT",
                selectionId: parseFloat(betData.selectionId),
                side: !!bet.bet_for ? bet.bet_for.toUpperCase() : 'UNKNOWN',
                limitOrder: {
                    size: parseFloat(parseFloat(betData.bid_amount.toString()).toFixed(2)),
                    price: parseFloat(parseFloat(betData.bid_at.toString()).toFixed(2)),
                    persistenceType: "PERSIST"
                },
            },
        }
        if (!!betData.bid_line && betData.bid_line > 0) {
            body.placeInstruction.selectionId = betData.bid_line
        }
        orderService.placeOrder(body).then((res) => {
            if (res.isSuccess !== false && !res.errors) {
                if (!res.exception.message) {
                    res = [res]
                    if (res[0].marketBettingType === "LINE" && res[0].marketName) {
                        res[0].runnerName = res[0].marketName
                    }
                    let deactivatMarkets = this.state.deactivatMarkets
                    let data = res.concat(this.state.matched_bet)
                    data = data.filter((bet) => {
                        return deactivatMarkets.indexOf(bet.marketId) === -1
                    })
                    this.setState({ matched_bet: data })
                } else {
                    this.props.notify(res.exception.message, "error")
                }
                setTimeout(() => {
                    this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
                }, bet.market.betDelay)
            } else {
                this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
                this.props.notify(!!res.exception.message ? res.exception.message : "Bet failed due to mismatch data.", "error")
            }
        })
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    onMessage(data) {
        data = JSON.parse(data)
        this.setState({ frontData: data })
    }
    resultDeclered(payload) {
        let deactivatMarkets = this.state.deactivatMarkets
        let matchedBets = this.state.matched_bet
        if (!!payload && !!payload.marketId) {
            deactivatMarkets.push(payload.marketId)
        }
        matchedBets = matchedBets.filter((bet) => {
            return deactivatMarkets.length > 0 && deactivatMarkets.indexOf(bet.marketId) === -1
        })
        this.setState({ matched_bet: matchedBets, deactivatMarkets: deactivatMarkets })
    }
    showExpo(data) {
        this.setState({ showExpo: true, lineExpo: data })
    }
    hidePopup() {
        this.setState({ showExpo: false, betSlipOpen: false, lineExpo: {} })
    }
    calc(theform) {
        var num = theform.original.value, rounded = theform.rounded
        var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
        rounded.value = with2Decimals
    }
    getAccountData() {
        let data = localStorage.getItem("accountData")
        data = JSON.parse(data)
        return data
    }
    async componentDidMount() {
        let selectedEvent = {}
        let teamSequence = []
        const accData = this.getAccountData();
        let evetData = await eventService.getUserEventById(this.props.match.params.event_id)
        let events = []

        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if (!(!!userData && !!userData.sub)) {
            authUtil.logout();
        } else {
            this.setState({ accounts: userData.sub });
        }
        localStorage.removeItem("betForm");
        localStorage.removeItem("betExpo");
        if (evetData.metadata && !!evetData.metadata.score) {
            this.setState({ frontData: evetData.metadata.score })
        }
        if (!evetData.catalogues || evetData.catalogues.length === 0) {
            return false
        }
        let runners = evetData.catalogues.filter((mkt) => {
            return mkt.marketType === "MATCH_ODDS"
        })[0]
        if (!!runners) {
            runners = runners.runners
            teamSequence = runners.map((r) => { return r = r.name })
        } else {
            runners = evetData.catalogues[0].runners
        }
        this.setState({ runners: runners, teamSequence: teamSequence })
        selectedEvent = events.filter((e, i) => {
            return e.id === this.props.match.params.event_id
        })
        let evtList = [this.props.match.params.event_id]
        if (!!accData && Object.keys(accData).length > 0) {
            await eventService.getMatchedBets({ "id": evtList.toString() }).then((res) => {
                if (!!res && res.isSuccess) {
                    mBets = []
                    res.items.forEach((bet) => {
                        bet.eventName = evetData.eventName
                        if (bet.marketBettingType === "LINE") {
                            bet.runnerName = bet.marketName
                        }
                        mBets.push(bet)
                    })
                }
            })
        }
        // mBets = mBets.reverse()
        evetData.catalogues && evetData.catalogues.forEach((market, i) => {
            if (!!evetData.metadata.books[market.marketId]) {
                // let mktBook = stringParser.deSrlz("book|" + evetData.metadata.books[market.marketId])
                let mktBook = JSON.parse(evetData.metadata.books[market.marketId])
                evetData.catalogues[i].metadata = {}
                evetData.catalogues[i].metadata.book = mktBook
            }

        })
        evetData.catalogues = evetData.catalogues.filter((mkt) => {
            return !!mkt.metadata && !!mkt.metadata.book && (mkt.provider === "SKY" || mkt.provider === "BETFAIR" || (mkt.provider === "BETHUBS" && (mkt.marketType.substring(0, 3) === "SES" || mkt.marketType.substring(0, 2) === "BM")))
        })
        var moPos = evetData.catalogues.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
        if (moPos !== -1) {
            let mom = [evetData.catalogues[moPos]]
            evetData.catalogues.splice(moPos, 1)
            evetData.catalogues = mom.concat(evetData.catalogues)
        }
        let fancy_mkts = evetData.catalogues.filter((mkt) => {
            return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && !!mkt.metadata && !!mkt.metadata.book && !!mkt.metadata.book.marketId && (mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE")
        })
        let line_mkts = []
        evetData.catalogues = evetData.catalogues.filter((mkt) => {
            return mkt.marketType.substring(0, 3) !== "SES" && mkt.bettingType !== "LINE"
        })
        fancy_mkts = fancy_mkts.sort((a, b) => a.marketId - b.marketId);
        let tvUrl = (!!accData && Object.keys(accData).length > 0) ? evetData.event.tvUrl : "";
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        this.setState({ pinnedEvents: pinnedEvents, game: evetData, matched_bet: mBets, unmatched_bet: umBets, gameCode: this.props.match.params.event, event: selectedEvent, loading: false, fancyMarkets: fancy_mkts, lineMarkets: line_mkts, tvUrl: tvUrl }, () => {
            setInterval(async () => {
                evetData = await eventService.getUserEventById(this.props.match.params.event_id)
                if (!evetData.catalogues) {
                    return false
                }
                evetData.catalogues && evetData.catalogues.forEach((market, i) => {
                    if (!!evetData.metadata.books[market.marketId]) {
                        // let mktBook = stringParser.deSrlz("book|" + evetData.metadata.books[market.marketId])
                        let mktBook = JSON.parse(evetData.metadata.books[market.marketId])
                        evetData.catalogues[i].metadata = {}
                        evetData.catalogues[i].metadata.book = mktBook
                    }
                })
                evetData.catalogues = !!evetData.catalogues ? evetData.catalogues.filter((mkt) => {
                    return !!mkt.metadata && !!mkt.metadata.book && (mkt.provider === "SKY" || mkt.provider === "BETFAIR" || (mkt.provider === "BETHUBS" && (mkt.marketType.substring(0, 3) === "SES" || mkt.marketType.substring(0, 2) === "BM")))
                }) : []
                var moPos = evetData.catalogues.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
                if (moPos !== -1) {
                    let mom = [evetData.catalogues[moPos]]
                    evetData.catalogues.splice(moPos, 1)
                    evetData.catalogues = mom.concat(evetData.catalogues)
                }
                let fancy_mkts = evetData.catalogues.filter((mkt) => {
                    return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && !!mkt.metadata && !!mkt.metadata.book && !!mkt.metadata.book.marketId && (mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE")
                })
                evetData.catalogues = evetData.catalogues.filter((mkt) => {
                    return mkt.marketType.substring(0, 3) !== "SES" && mkt.bettingType !== "LINE"
                })
                fancy_mkts = fancy_mkts.sort((a, b) => a.marketId - b.marketId);
                this.setState({ game: {}, fancyMarkets: [] }, () => {
                    this.setState({ game: Object.assign({}, evetData), fancyMarkets: Object.assign([], fancy_mkts) })
                })
            }, ((!!accData && Object.keys(accData).length > 0) ? 15000 : 60000))
        })
    }
    betForm(market, bet) {
        if (market === null && bet === null) {
            localStorage.removeItem("betForm");
            localStorage.removeItem("betExpo");
        }
        this.setState({ selected_market: market, selcted_bet_option: bet })
    }
    formatDate(date) {
        if (!date) {
            return ""
        }
        date = new Date(date)
        let month = [];
        month[0] = "Jan";
        month[1] = "Feb";
        month[2] = "Mar";
        month[3] = "Apr";
        month[4] = "May";
        month[5] = "Jun";
        month[6] = "Jul";
        month[7] = "Aug";
        month[8] = "Sept";
        month[9] = "Oct";
        month[10] = "Nov";
        month[11] = "Dec";
        let mn = date.getMonth() + 1;
        mn = mn > 9 ? mn : "0" + mn
        let dt = date.getDate();
        dt = dt > 9 ? dt : "0" + dt
        let hr = date.getHours();
        hr = hr > 9 ? hr : "0" + hr
        let min = date.getMinutes();
        min = min > 9 ? min : "0" + min
        let year = date.getFullYear()
        let formatedDate = dt + "/" + mn + "/" + year + " " + hr + ":" + min
        return formatedDate
    }
    toggleMultiMarket(eventId) {
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        let eventIndex = pinnedEvents.indexOf(eventId)
        if (eventIndex === -1) {
            pinnedEvents.push(eventId)
        } else {
            pinnedEvents.splice(eventIndex, 1)
        }
        localStorage.setItem("pinnedEvents", pinnedEvents.toString())
        this.setState({ pinnedEvents: pinnedEvents })
    }
    arrayGroupBy(ary, attr) {
        let group = ary.reduce((r, a) => {
            r[a[attr]] = [...r[a[attr]] || [], a];
            return r;
        }, {});
        return group
    }
    orgenizedFancy(markets) {
        if (!markets) {
            return {};
        }
        let newObj = {}

        if (!!markets["THREE_SELECTIONS"]) {
            newObj["THREE_SELECTIONS"] = markets["THREE_SELECTIONS"]
            delete markets["THREE_SELECTIONS"]
        }
        if (!!markets["1ST_INNINGS_RUNS"]) {
            newObj["1ST_INNINGS_RUNS"] = markets["1ST_INNINGS_RUNS"]
            delete markets["1ST_INNINGS_RUNS"]
        }
        if (!!markets["2ND_INNINGS_RUNS"]) {
            newObj["2ND_INNINGS_RUNS"] = markets["2ND_INNINGS_RUNS"]
            delete markets["2ND_INNINGS_RUNS"]
        }
        if (!!markets["1_INN_25_BALL_LINE"]) {
            newObj["1_INN_25_BALL_LINE"] = markets["1_INN_25_BALL_LINE"]
            delete markets["1_INN_25_BALL_LINE"]
        }
        if (!!markets["1_INN_50_BALL_LINE"]) {
            newObj["1_INN_50_BALL_LINE"] = markets["1_INN_50_BALL_LINE"]
            delete markets["1_INN_50_BALL_LINE"]
        }
        if (!!markets["1_INN_75_BALL_LINE"]) {
            newObj["1_INN_75_BALL_LINE"] = markets["1_INN_75_BALL_LINE"]
            delete markets["1_INN_75_BALL_LINE"]
        }
        if (!!markets["1_INN_100_BALL_LINE"]) {
            newObj["1_INN_100_BALL_LINE"] = markets["1_INN_100_BALL_LINE"]
            delete markets["1_INN_100_BALL_LINE"]
        }
        if (!!markets["2_INN_25_BALL_LINE"]) {
            newObj["2_INN_25_BALL_LINE"] = markets["2_INN_25_BALL_LINE"]
            delete markets["2_INN_25_BALL_LINE"]
        }
        if (!!markets["2_INN_50_BALL_LINE"]) {
            newObj["2_INN_50_BALL_LINE"] = markets["2_INN_50_BALL_LINE"]
            delete markets["2_INN_50_BALL_LINE"]
        }
        if (!!markets["2_INN_75_BALL_LINE"]) {
            newObj["2_INN_75_BALL_LINE"] = markets["2_INN_75_BALL_LINE"]
            delete markets["2_INN_75_BALL_LINE"]
        }
        if (!!markets["2_INN_100_BALL_LINE"]) {
            newObj["2_INN_100_BALL_LINE"] = markets["2_INN_100_BALL_LINE"]
            delete markets["2_INN_100_BALL_LINE"]
        }

        // if (!!markets["1_INNING_6_OVR_LINE"]) {
        //     newObj["1_INNING_6_OVR_LINE"] = markets["1_INNING_6_OVR_LINE"]
        //     delete markets["1_INNING_6_OVR_LINE"]
        // }
        // if (!!markets["1_INNING_10_OVR_LINE"]) {
        //     newObj["1_INNING_10_OVR_LINE"] = markets["1_INNING_10_OVR_LINE"]
        //     delete markets["1_INNING_10_OVR_LINE"]
        // }
        // if (!!markets["1_INNING_15_OVR_LINE"]) {
        //     newObj["1_INNING_15_OVR_LINE"] = markets["1_INNING_15_OVR_LINE"]
        //     delete markets["1_INNING_15_OVR_LINE"]
        // }
        // if (!!markets["1_INNING_20_OVR_LINE"]) {
        //     newObj["1_INNING_20_OVR_LINE"] = markets["1_INNING_20_OVR_LINE"]
        //     delete markets["1_INNING_20_OVR_LINE"]
        // }
        // if (!!markets["2_INNING_6_OVR_LINE"]) {
        //     newObj["2_INNING_6_OVR_LINE"] = markets["2_INNING_6_OVR_LINE"]
        //     delete markets["2_INNING_6_OVR_LINE"]
        // }
        // if (!!markets["2_INNING_10_OVR_LINE"]) {
        //     newObj["2_INNING_10_OVR_LINE"] = markets["2_INNING_10_OVR_LINE"]
        //     delete markets["2_INNING_10_OVR_LINE"]
        // }
        // if (!!markets["2_INNING_15_OVR_LINE"]) {
        //     newObj["2_INNING_15_OVR_LINE"] = markets["2_INNING_15_OVR_LINE"]
        //     delete markets["2_INNING_15_OVR_LINE"]
        // }
        // if (!!markets["2_INNING_20_OVR_LINE"]) {
        //     newObj["2_INNING_20_OVR_LINE"] = markets["2_INNING_20_OVR_LINE"]
        //     delete markets["2_INNING_20_OVR_LINE"]
        // }
        if (!!markets["OVERS"]) {
            newObj["OVERS"] = markets["OVERS"]
            delete markets["OVERS"]
        }
        if (!!markets["SINGLE_OVER"]) {
            newObj["SINGLE_OVER"] = markets["SINGLE_OVER"]
            delete markets["SINGLE_OVER"]
        }
        if (!!markets["BATSMAN"]) {
            newObj["BATSMAN"] = markets["BATSMAN"];
            delete markets["BATSMAN"];
        }
        if (!!markets["BALL_BY_BALL"]) {
            newObj["BALL_BY_BALL"] = markets["BALL_BY_BALL"]
            delete markets["BALL_BY_BALL"]
        }
        if (!!markets["ODD_EVEN"]) {
            newObj["ODD_EVEN"] = markets["ODD_EVEN"]
            delete markets["ODD_EVEN"]
        }
        if (!!markets["OTHERS"]) {
            newObj["OTHERS"] = markets["OTHERS"]
            delete markets["OTHERS"]
        }
        newObj = { ...newObj, ...markets }
        let fancys = []
        Object.keys(newObj).forEach((type) => {
            newObj[type] = newObj[type].sort((a, b) => {
                return a.sortPriority - b.sortPriority;
            });
            fancys = fancys.concat(newObj[type])
        })
        return fancys
    }
    userPropertyUpdate(market) {
        let userMktCondition = localStorage.getItem("accountData")
        userMktCondition = JSON.parse(userMktCondition)
        if (!userMktCondition || !market.marketCondition) {
            return market
        }
        market.minBet = !!userMktCondition && userMktCondition.minBet ? Math.max(market.marketCondition.minBet, userMktCondition.minBet) : market.marketCondition.minBet
        if (market.marketCondition.maxBet === 0) {
            market.maxBet = userMktCondition.maxBet
        } else if (userMktCondition.maxBet === 0) {
            market.maxBet = market.marketCondition.maxBet
        } else {
            market.maxBet = market.marketCondition.maxBet
        }
        market.betDelay = Math.max(market.marketCondition.betDelay, userMktCondition.betDelay)
        return market
    }
    render() {
        const accData = this.getAccountData();
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateSocket={(skt) => { this.updateSocket(skt) }} orderPlaced={(ord) => { this.orderPlaced(ord) }} resultDeclered={(payload) => { this.resultDeclered(payload) }} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} />
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                    <div className="col-centersdetails markets">
                        <div className="">
                            <div className=" live-match">
                                <div className="sub_path center-box crname">
                                    <p>
                                        {!!this.state.game && !!this.state.game.event && !!this.state.game.competition && <>{!!this.state.game.catalogues && this.state.game.catalogues.length > 0 && <a id="multiMarketPin" title="Remove from Multi Markets" onClick={(e) => { e.stopPropagation(); this.toggleMultiMarket(this.state.game.catalogues[0].marketId); }} className={this.state.pinnedEvents.indexOf(this.state.game.catalogues[0].marketId) > -1 ? "multimarket-pin select" : "multimarket-pin"} style={{ "cursor": "pointer" }}><i className="fa fa-thumb-tack" aria-hidden="true"></i></a>}<span style={{ fontSize: 15 }}>{!!this.state.game && !!this.state.game.event["name"] ? this.state.game.event["name"] + " - Winner" : null} </span></>}
                                    </p>
                                </div>
                                <div className="game-wrap col3">
                                    <div className="middle-in-play">
                                        <div className={!!this.state.frontData.s && this.state.frontData.s !== "NA" ? "scorecard m-b-5  scorecard-massage " : "scorecard m-b-5  "}>
                                            <div className="row">
                                                <div className="col-6 col-md-6">{!!this.state.game && this.state.game.event && <span className="commentary" style={{ color: "white" }}><i style={{ color: "white", fontSize: "20" }} className="flaticon-clock" aria-hidden="true"></i> {this.formatDate(this.state.game.event["openDate"])}</span>}</div>
                                                <div className="col-6 col-md-6 ">
                                                    {!!this.state.game.catalogues && this.state.game.catalogues.length > 0 && <span className="commentary" style={{ color: "white", float: 'right' }}> Min: {this.userPropertyUpdate(this.state.game.catalogues[0].minBet)} | Max: {this.userPropertyUpdate(this.state.game.catalogues[0].maxBet)} </span>}
                                                </div>
                                            </div>
                                            {!!this.state.frontData.s && this.state.frontData.s !== "NA" && <div className="ballstatuscricket">{this.state.frontData.s === 'OVR' ? "Match Over" : this.state.frontData.s === 'RAIN' ? "Rain interupted match." : this.state.frontData.s === 'TU' ? "Third Umpire" : this.state.frontData.s === 'NO' ? "Not Out" : this.state.frontData.s === 'RE' ? "Review Decision" : this.state.frontData.s === 'DR' ? "Drinks Break" : this.state.frontData.s === 'LU' ? "Lunch Break" : this.state.frontData.s === 'TEA' ? "Tea Break" : this.state.frontData.s === 'IB' ? "Innings Break" : this.state.frontData.s === 'ST' ? "Stumps" : this.state.frontData.s === 'DEL' ? "Match Delay" : this.state.frontData.s === 'WOF' ? "Wet Out Field" : this.state.frontData.s === 'OT' ? "Out" : this.state.frontData.s === 'NB' ? "No Ball" : this.state.frontData.s === 'FH' ? "Free Hit" : this.state.frontData.s === 'STO' ? "Strategic Time-Out" : this.state.frontData.s === 'BR' ? "Ball Chalu" : ""}</div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                {
                                    !!this.state.game.catalogues && this.state.game.catalogues.map((market, i) => {
                                        return <WebMarket  updateMktMsg = {(msg)=>{this.updateMktMsg(market.marketId, msg)}} hideMkt={[]} hideHeader={true} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} teamSequence={this.state.teamSequence} socket={this.props.socket} curBets={this.state.matched_bet} notify={(msg, type) => { this.props.notify(msg, type) }} market={market} addBet={(bet) => { this.addBet(bet) }} selected_market={this.state.selected_market} selcted_bet_option={this.state.selcted_bet_option} betForm={(market, bet) => { this.betForm(market, bet) }} toggleMultiMarket={(marketId) => { this.toggleMultiMarket(marketId) }} pinnedEvents={this.state.pinnedEvents} />
                                    })
                                }
                            </div>
                            <div className="">
                                {this.state.fancyMarkets.length > 0 && <div className={"live-match "}>
                                    <div className="sub_path center-box crname">
                                        <p>
                                            <span>Fancy </span>
                                        </p>
                                    </div>
                                    <div className="game-wrap col3">
                                        <table className="table w-100 game-list-col fancytable mb-0">
                                            <tr className="bet-all-new">
                                                <td className="pb-0">&nbsp;</td>
                                                <td className="w-16 pb-0">
                                                    <div>
                                                        <div className="">
                                                            <a id="btnBack" className="btn-back bg-trans" side="Back">
                                                                <span>No</span>
                                                            </a>
                                                        </div>
                                                        <div>
                                                            <a id="btnLay" className="btn-lay bg-trans" side="Lay">
                                                                <span>Yes</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="w-16 mobile-hide pb-0">
                                                    &nbsp;
                                                </td>
                                            </tr>
                                            {
                                                this.state.fancyMarkets.map((mkt, i) => {
                                                    return <Fancybook feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} key={"fancy_" + i} socket={this.props.socket} showExpo={(data) => { this.showExpo(data) }} curBets={this.state.matched_bet} index={i} type={"ses"} notify={(msg, type) => { this.props.notify(msg, type) }} addBet={(bet) => { this.addBet(bet) }} selected_market={this.state.selected_market} selcted_bet_option={this.state.selcted_bet_option} betForm={(market, bet) => { this.betForm(market, bet) }} market={mkt} toggleMultiMarket={(marketId) => { this.toggleMultiMarket(marketId) }} pinnedEvents={this.state.pinnedEvents} />
                                                })
                                            }
                                        </table>
                                    </div>
                                </div>}
                            </div>
                            <div className="live-match livetv">
                                {!!this.state.tvUrl && this.state.tvUrl !== "" && <><div className="sub_path center-box crname">
                                    <p>
                                        <span>Live TV</span>
                                        <div className="custom-control custom-switch float-right" style={{ display: "inline" }}>
                                            <input type="checkbox" className="custom-control-input" checked={this.state.tvShow} onClick={() => { this.setState({ tvShow: !this.state.tvShow }) }} id="customSwitches" />
                                            <label className="custom-control-label" for="customSwitches"></label>
                                        </div>
                                    </p>
                                </div>
                                    <div className="game-wrap col3 mb-0">
                                        {!!this.state.tvShow && <div> <iframe title={"iframe"} key={"iframe"} id='fp_embed_player' src={this.state.tvUrl} marginWidth='0' marginHeight='0' frameBorder='0' width='100%' height='100%' scrolling='no' allowFullScreen='allowfullscreen'></iframe></div>}
                                    </div></>}

                                <div className="center-box mt-1">
                                    <div className="container-fluid titbg">
                                        <div className="w-100 float-left">
                                            <span onClick={() => { this.setState({ selected_list: "matched" }) }} className={this.state.selected_list === "matched" ? "betslip-btn active" : "betslip-btn"}>Matched Bet</span>
                                            {this.state.matched_bet.length > this.state.betLimit && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                        </div>
                                    </div>
                                    {this.state.selected_list === "matched" && <div className="mybet-alldata bg-white table-responsive">
                                        <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th>Matched Bet</th>
                                                    <th>Odds</th>
                                                    <th>Stake</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.matched_bet.map((bet, i) => {
                                                    return (
                                                        <>
                                                            {i < this.state.betLimit && <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                                <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                                <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                                <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                            </tr>}
                                                        </>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>}
                                    {this.state.selected_list === "unmatched" && <div className="mybet-alldata bg-white table-responsive">
                                        <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th>Matched Bet</th>
                                                    <th>Odds</th>
                                                    <th>Stake</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.unmatched_bet.map((bet) => {
                                                    return (
                                                        <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                            <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>{/* <td><img alt="" style={{ marginLeft: "38%" }} src={require('../images/close.png')} /></td> */}
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`col-right ${(!!accData && Object.keys(accData).length > 0) ? '' : 'col-right-login'}`}>
                        <div className="sub_path over-wrap">
                            {!!this.state.tvUrl && this.state.tvUrl !== "" && <><div className="center-box mb-1 inline">
                                <p>Live TV
                                    <div className="custom-control custom-switch float-right" style={{ display: "inline" }}>
                                        <input type="checkbox" className="custom-control-input" checked={this.state.tvShow} onClick={() => { this.setState({ tvShow: !this.state.tvShow }) }} id="customSwitches" />
                                        <label className="custom-control-label" for="customSwitches"></label>
                                    </div>
                                </p>
                            </div>
                                {!!this.state.tvShow && <div className="mb-2"> <iframe title={"iframe mobile"} key={"iframe_mob"} id='fp_embed_player' src={this.state.tvUrl} marginWidth='0' marginHeight='0' frameBorder='0' width='100%' height='100%' scrolling='no' allowFullScreen='allowfullscreen'></iframe></div>}</>}
                            <div className="center-box">
                                <div className="container-fluid titbg">
                                    <div className="w-100 float-left">
                                        <span onClick={() => { this.setState({ selected_list: "matched" }) }} className={this.state.selected_list === "matched" ? "betslip-btn active" : "betslip-btn"}>Matched Bet</span>
                                        {this.state.matched_bet.length > this.state.betLimit && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                    </div>
                                </div>
                                {this.state.selected_list === "matched" && <div className="mybet-alldata bg-white table-responsive">
                                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.matched_bet.map((bet, i) => {
                                                return (
                                                    <>
                                                        {i < this.state.betLimit && <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                            <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                        </tr>}
                                                    </>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}
                                {this.state.selected_list === "unmatched" && <div className="mybet-alldata bg-white table-responsive">
                                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.unmatched_bet.map((bet) => {
                                                return (
                                                    <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                        <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                        <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                        <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}
                            </div>
                        </div>
                    </div>
                    {this.state.showExpo && <ExpoPopup lineExpo={this.state.lineExpo} hidePopup={() => { this.hidePopup() }} />}
                    {this.state.betSlipOpen && <BetSlipPopup bets={this.state.matched_bet} hidePopup={() => { this.hidePopup() }} />}
                </div>
            </body>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Event);